import "./PodcastStudioInPinheiros.module.css";
import Header from "@/reusable_sections/Header";
import HeroDelCatalogo from "./sections/HeroDelCatalogo";
import EstrutuiraEQualidade from "./sections/EstrutuiraEQualidade";
import ServicesSection from "./sections/ServicesSection";
import Diferencial from "./sections/Diferencial";
import FourEasySteps from "./sections/FourEasySteps";
import TechnologicalCycle from "./sections/TechnologicalCycle";
import Localizacao from "./sections/Localizacao";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
import FaqAccordion from "./sections/FaqAccordion";
import VersatileContent from "./sections/VersatileContent";
import SwatchesAndTour from "./sections/SwatchesAndTour";
export default function PodcastStudioInPinheirosPage() {
  return <div>
      <Header />
      <HeroDelCatalogo />
      <EstrutuiraEQualidade />
      <ServicesSection />
      <Diferencial />
      <FourEasySteps />
      <FaqAccordion />
      <TechnologicalCycle />
      <VersatileContent />
      <SwatchesAndTour />
      <Localizacao />
      <CallToAction />
      <Footer />
    </div>;
}